import {Langue, useLangue} from '../i18n/langue';

/**
 * Deux lettres, et celle qui est active se détache.
 *
 * Pas de menu déroulant pour deux choix : il faudrait l'ouvrir pour voir ce
 * qu'il contient, là où deux boutons disent tout et changent la langue d'un
 * clic.
 */
export const SelecteurDeLangue = () => {
    const {langue, choisir} = useLangue();

    const bouton = (valeur: Langue, libelle: string) => (
        <button
            key={valeur}
            onClick={() => choisir(valeur)}
            aria-pressed={langue === valeur}
            className={`px-2 py-0.5 text-xs font-medium rounded-pill transition-colors ${
                langue === valeur
                    ? 'bg-primary/10 text-primary'
                    : 'text-gray-400 hover:text-primary'
            }`}
        >
            {libelle}
        </button>
    );

    return (
        <div className="flex items-center gap-0.5" role="group" aria-label={langue === 'fr' ? 'Langue' : 'Language'}>
            {bouton('fr', 'FR')}
            {bouton('en', 'EN')}
        </div>
    );
};
